require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-were-bics-main-takeaways-from-the-2024-world.json") })
        }
      }, "path---en-us-update-what-were-bics-main-takeaways-from-the-2024-world");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-were-bics-main-takeaways-from-the-2024-world!./.cache/json/en-us-update-what-were-bics-main-takeaways-from-the-2024-world.json
// module id = 856
// module chunks = 231608221292675